<template>
  <div id="app">
    <comheader></comheader>
    <div class="lf ks_right" id="rmodel">
      <comtop></comtop>
      <el-main>
        <el-button type="primary" @click="dialogVisible = true" class="ad_view"
          >新增一级分类</el-button
        >
        <p class="tips red">带*号的为对"君臣论-经验课"分类</p>
        <div class="view_wrap">
          <el-tree
            :data="data"
            :props="defaultProps"
            class="view_tree"
            @current-change="nodeHover"
            ref="tree"
            node-key="cid"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span
                ><span v-if="node.data.type === '2'" class="red">*</span
                >{{ node.data.name }}</span
              >
              <span class="rfcustom">
                <!-- <el-button
                   v-if="data.pid!=='0'"
                    type="text"
                    size="mini"
                    @click="movechild(node,data)" >
                    移动分类
                  </el-button> -->
                <el-button type="text" size="mini" @click="upchild(node, data)">
                  添加子分类
                </el-button>
                <el-button type="text" size="mini" @click="rname(node, data)">
                  修改名称
                </el-button>
                <el-button type="text" size="mini" @click="remove(node, data)">
                  删除
                </el-button>
              </span>
            </span>
          </el-tree>
        </div>
      </el-main>
      <el-dialog
        title="添加一级分类"
        :visible.sync="dialogVisible"
        :lock-scroll="false"
        custom-class="viewsBox"
      >
        <div class="input_wrap">
          <span>分类名称</span>
          <div class="form-item">
            <el-input
              v-model="input"
              placeholder="最多输入15个字"
              maxlength="15"
            ></el-input>
          </div>
          <span>分类类型</span>
          <div class="form-item">
            <el-select v-model="type" clearable placeholder="请选择">
              <el-option
                v-for="item in typeClass"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <!-- <div class="form-item">
            <el-form-item label="类型" prop="type" class="AddInput">
              <el-select v-model="addForm.type" clearable placeholder="请选择">
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div> -->
          <!-- <el-form
            ref="category"
            :model="categoryForm"
            :rules="rules"
            class="category-form"
          >
          </el-form> -->
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="upView">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="添加子分类"
        :visible.sync="upchil"
        :lock-scroll="false"
        custom-class="viewsBox"
      >
        <div class="input_wrap">
          <span>分类名称</span>
          <el-input
            v-model="input"
            placeholder="最多输入15个字"
            maxlength="15"
          ></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="upchil = false">取 消</el-button>
          <el-button type="primary" @click="upchilView(node, data)"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="修改分类名字"
        :visible.sync="rename"
        :lock-scroll="false"
        custom-class="viewsBox"
      >
        <div class="input_wrap">
          <span>分类名称</span>
          <el-input
            v-model="input"
            placeholder="最多输入15个字"
            maxlength="15"
          ></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="rename = false">取 消</el-button>
          <el-button type="primary" @click="reViewName">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="移动分类"
        :visible.sync="movecl"
        :lock-scroll="false"
        custom-class="viewsBox"
      >
        <div class="input_wrap">
          <span>分类名称</span>
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="movecl = false">取 消</el-button>
          <el-button type="primary" @click="reViewName">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import comheader from "./Common/comheader";
import comtop from "./Common/comtop";

export default {
  inject: ["reload"],
  name: "viewsGroup",
  data() {
    return {
      data: [],
      input: "",
      options: [],
      dialogVisible: false,
      movecl: false,
      rename: false,
      upchil: false,
      udata: "",
      cid: "",
      url: this.HOME,
      defaultProps: {
        children: "son",
        label: "name",
      },
      type: "",
      upType: "",
    };
  },
  components: {
    comheader,
    comtop,
  },
  mounted() {
    var data = [];
    this.$axios
      .post(
        this.url,
        this.$qs.stringify({
          service: "Cate.Cateinfo",
          userid: localStorage.getItem("userid"),
        })
      )
      .then((res) => {
        const data = res.data.data;
        // const startData = data.map((item) => {
        //   item.type === "2" && (item.name = "*" + item.name);
        //   return item;
        // });
        this.data = data;
      });
  },
  methods: {
    movechild(node, data) {
      this.cid = data.c_id;
      this.udata = data;
      this.movecl = true;
      this.upType = data.type;
    },
    upView() {
      var data = {
        service: "Cate.Cateadd",
        name: this.input,
        type: this.type,
        userid: localStorage.getItem("userid"),
      };
      if (!data.name.trim()) {
        this.alertView.failView("请输入分类名称!");
        return false;
      } else if (data.type === "") {
        this.alertView.failView("请选择分类类型!");
        return false;
      }
      var dataList = this.data;
      this.$axios.post(this.url, this.$qs.stringify(data)).then((res) => {
        if (res.data.data.code == 0) {
          this.dialogVisible = false;
          this.alertView.successView(res.data.data.msg);
          this.reload();
        } else {
          this.alertView.failView(res.data.data.msg);
        }
      });
    },
    upchild(node, data) {
      console.log(node);
      event.stopPropagation();
      this.cid = data.c_id;
      this.upchil = true;
      this.upType = data.type;
    },
    rname(node, data) {
      event.stopPropagation();
      this.cid = data.c_id;
      this.udata = data;
      this.rename = true;
      this.upType = data.type;
    },
    upchilView(node, d) {
      var data = {
        service: "Cate.Catesonadd",
        name: this.input,
        pid: this.cid,
        userid: localStorage.getItem("userid"),
        type: this.upType,
      };
      this.$axios.post(this.url, this.$qs.stringify(data)).then((res) => {
        console.log(res);
        if (res.data.data.code == 0) {
          this.dialogVisible = false;
          this.alertView.successView(res.data.data.msg);
          this.reload();
        } else {
          this.alertView.failView(res.data.data.msg);
        }
      });
    },
    reViewName() {
      var data = {
        service: "Cate.Cateupdate",
        name: this.input,
        cid: this.cid,
        userid: localStorage.getItem("userid"),
      };
      this.$axios.post(this.url, this.$qs.stringify(data)).then((res) => {
        if (res.data.data.code == 0) {
          this.alertView.successView(res.data.data.msg);
          this.udata.name = this.input;
          this.rename = false;
        } else {
          this.alertView.failView(res.data.data.msg);
        }
      });
    },
    remove(node, data) {
      event.stopPropagation();
      var data = {
        service: "Cate.Catedel",
        cid: data.c_id,
        userid: localStorage.getItem("userid"),
      };
      this.$axios.post(this.url, this.$qs.stringify(data)).then((res) => {
        if (res.data.data.code == 0) {
          this.alertView.successView(res.data.data.msg);
          this.reload();
        } else {
          this.alertView.failView(res.data.data.msg);
        }
      });
    },
    nodeHover(e) {
      console.log(e);
    },
  },
};
</script>
<style>
@import "../assets/css/view.css";
.red {
  color: #ff0000;
}
.tips {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/viewsGroup.vue